import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import PublicRoutes from './_config/publicRoutes';
import { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import 'primereact/resources/primereact.min.css'; 
import 'primereact/resources/themes/saga-blue/theme.css'; 
import 'primeicons/primeicons.css';
import { URLS } from './_config';
import Login from './pages/login';
import SSOLogin from './pages/ssoLogin';
import PrivateRoutes from './_config/privateRoutes';
import Page404 from './pages/404';
import SignUp from './pages/signup';
import ForgotPassword from './pages/forgotPassword';
import ResetPassword from './pages/set-password/resetPassword';
import StoreCreate from './pages/wallet-store/addStore';
import Branches from './pages/wallet-store/branches';
import Settings from './pages/settings/settings';
import Word from './pages/word/words';
import Stores from './pages/wallet-store/stores';
import Sentiment from './pages/dashboard/sentiment';
import DataSources from './pages/settings/dataSources';
import Reviews from './pages/sentiment-reviews/reviews';
import Topics from './pages/topic/topics';
import Ratings from './pages/sentiment-ratings/ratings';
import HubWalletAssistant from './pages/hubwallet-assistant/assistant';
import Recommendation from './pages/recommendation/recommendation';
import Profile from './pages/user-profile/profile';
import ModuleSelection from './pages/ModuleSelection';

function App() {
	const storeRef = useRef<any>(null);

	useEffect(() => {
		if (storeRef.current) {
			storeRef.current.getStores(); // Automatically call getStores when component loads
		}
	}, []);

	return (
		<Router basename={process.env.PUBLIC_URL}>

			<div className="App">
				<Routes>
					{/* SSO Login - standalone route without PublicRoutes wrapper */}
					<Route path={URLS.USER.SSO_LOGIN} element={<SSOLogin />}></Route>

					<Route element={<PublicRoutes />}>
						<Route path="/" element={<Navigate to="/login" />} /> 
						<Route path={URLS.USER.LOGIN} element={<Login />}></Route>
						<Route path={URLS.USER.SIGNUP} element={<SignUp />}></Route>
						<Route path={URLS.USER.FORGOT_PASSWORD} element={<ForgotPassword />}></Route>
						<Route path={URLS.USER.RESET_PASSWORD} element={<ResetPassword />}></Route>
					</Route>

					{/* <Route path={URLS.RESET_PASSWORD} element={<ResetPassword />}></Route> */}

					
					<Route element={<PrivateRoutes />}>
						<Route path="/" element={<Navigate to={URLS.DASHBOARD} />} /> 
						{/* <Route path={URLS.STORE.LIST} element={<Stores />}></Route> */}
						<Route path={URLS.STORE.CREATE} element={<StoreCreate />}></Route>
						<Route path={URLS.STORE.BRANCHES} element={<Branches />}></Route>
						<Route path={URLS.DATASOURCES.CREATE} element={<Settings />}></Route>
						<Route path={URLS.DATASOURCES.LIST} element={<DataSources />}></Route>
						<Route path={URLS.DASHBOARD} element={<Sentiment />}></Route>
						<Route path={URLS.WORD} element={<Word />}></Route>
						<Route path={URLS.REVIEW} element={<Reviews />}></Route>
						<Route path={URLS.RATING} element={<Ratings />}></Route>
						<Route path={URLS.TOPIC} element={<Topics />}></Route>
						<Route path={URLS.ASSISTANT.SEND} element={<HubWalletAssistant />}></Route>
						<Route path={URLS.RECOMMENDATION.RECOMMENDATION_LIST} element={<Recommendation />}></Route>
						<Route path={URLS.SETTINGS} element={<Profile />}></Route>
						<Route path={URLS.MODULE_SELECTION} element={<ModuleSelection />}></Route>
					</Route>

					<Route path={`*`} element={<Page404 />}></Route>
				</Routes>
			</div>
		</Router>
	);
}

export default App;
